import React, { Component } from "react";
import UploadContext, { DEFAULT_UPLOAD_CONTEXT, getAcceptedFormatsByAcceptedMedia } from "./UploadContext";
import { IUploadContext, UploadFormat } from "../../../laco-common/base/models/upload";

export default class UploadProvider extends Component<IUploadContext> {
	render() {
		let uploadFormat: UploadFormat = this.props.format;
		if (!uploadFormat && this.props.mediaAccepted) {
			uploadFormat = getAcceptedFormatsByAcceptedMedia(this.props.mediaAccepted);
		}
		console.log("uploadFormat:", uploadFormat);
		return (
			<UploadContext.Provider
				value={{
					...DEFAULT_UPLOAD_CONTEXT,
					...this.props,
					format: uploadFormat || DEFAULT_UPLOAD_CONTEXT.format,
				}}
			>
				{this.props.children}
			</UploadContext.Provider>
		);
	}
}
